import { render } from "./Products.vue?vue&type=template&id=6a0d557a"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
script.render = render

export default script